// eslint-disable-next-line no-unused-vars
import React from "react";

const TableTotalNCost = ({
  noOfReportLable = "",
  noOfReportLength,
  totalRequestFeeCostLable = "",
  totalRequestFeeCostValue = "",
  totalReportFeeCostLable = "",
  totalReportFeeCostValue = "",
  totalInvestigationCostLable = "",
  totalInvestigationCostValue = "",
}) => {
  return (
    <div className="totalsBlockWrapper">
      <div className="totalReportsBlock">
        <span>{noOfReportLable}</span>
        <h2>{noOfReportLength}</h2>
      </div>
      <div className="totalRequestReportWrapper">
        {totalInvestigationCostLable && (
          <div className="totalFeeCostBlock">
            <span>{totalInvestigationCostLable}</span>
            <h1>
              GHC
              {totalInvestigationCostValue}
            </h1>
          </div>
        )}
        {totalRequestFeeCostLable && (
          <div className="totalFeeCostBlock">
            <span>{totalRequestFeeCostLable}</span>
            <h1>
              GHC
              {totalRequestFeeCostValue}
            </h1>
          </div>
        )}
        {totalReportFeeCostLable && (
          <div className="totalFeeCostBlock">
            <span>{totalReportFeeCostLable}</span>
            <h1>
              GHC
              {totalReportFeeCostValue}
            </h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableTotalNCost;
